import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { ParamContext } from '../../service/param.context';
import { Formula } from '../model/formula';
import { SERVER_API_URL } from '../../../environment.constants';
import { EnableSavingIndicator } from '../../loading-indicator';
import { Injectable } from '@angular/core';

@Injectable()
export class FormulaService {
    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    create(formula: Formula) {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/formula`;
        return this.http.post<Formula>(url, formula, { params, observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    update(formula: Formula) {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/formula/${formula.formulaId}`;
        return this.http.put<Formula>(url, formula, { params, observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    delete(formulaId: number) {
        const params: HttpParams = new HttpParams().append('programUUID', this.paramContext.programUUID);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/formula/${formulaId}`;
        return this.http.delete<any>(url, { params, observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

}
